import React from "react";
import EditingSettingsTableRow from "./editingSettingsTableRow";
import {calculateChildQuestionOptionName} from "../../helpers/applicationQuestionsUtils";

const EditingSettingsTable = (props) => {
    const {
        questions,
        editingSettings,
        editingSettingsValues,
        changeEditingSettings,
        editingSettingsOptions,
        getQuestionFromEditingSetting,
        getFieldFormEditingSetting,
        getEditingSettingFromQuestionId,
        getEditingSettingFromTableName
    } = props;

    //const editingSettingsForQuestions = editingSettings.filter(e => e.questionId);
    const editingSettingsForFields = editingSettings.filter(e => e.columnName);

    return (
        <div className={"table-responsive"}>
            <table className="table table-striped">
                <thead className="table-head">
                <tr>
                    <th className={"col-sm-8"}>Question</th>
                    <th className={"col-sm-4"}>Editable By</th>
                </tr>
                </thead>
                <tbody>
                {
                    editingSettingsForFields.map((editingSetting, index) => {
                        const field = getFieldFormEditingSetting(editingSetting);
                        return (
                            <EditingSettingsTableRow
                                key={index}
                                question={field}
                                childQuestionOptionName={""}
                                editingSetting={editingSetting}
                                editingSettingValue={editingSettingsValues[editingSetting.id]}
                                changeEditingSettings={changeEditingSettings}
                                editingSettingsOptions={editingSettingsOptions}
                            />
                        )
                    })
                }
                {
                    questions.map((question, index) => {
                        let editingSetting = {};
                        if(question.machineName === "OpponentName"){
                            editingSetting = getEditingSettingFromTableName("ApplicationOpponent");
                        } else if(question.machineName === "EstimateForMedicalExpertFees"){
                            editingSetting = getEditingSettingFromTableName("ApplicationMedicalExpertFees");
                        } else {
                            editingSetting = getEditingSettingFromQuestionId(question.id);
                        }
                        return (
                            <EditingSettingsTableRow
                                key={index}
                                question={question}
                                childQuestionOptionName={calculateChildQuestionOptionName(question.id, questions)}
                                editingSetting={editingSetting}
                                editingSettingValue={editingSettingsValues[editingSetting.id]}
                                changeEditingSettings={changeEditingSettings}
                                editingSettingsOptions={editingSettingsOptions}
                            />
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    )
};

export default EditingSettingsTable;